/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Spacer } from "components/views/atoms/Atoms"
import React from "react"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { useFormContext } from "react-hook-form"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { useSignUpFlow } from "components/context/signup/SignUpFlowContext"
import { useSignUpFindAccountSuccess } from "./context/SignUpFindAccountSuccessContext"
import styled from "styled-components"
import { H1, FlexContainer } from "@carrotfertility/carotene"
import { AppAccessPageLayout } from "components/access-page/AppAccessPageLayout"
import { AppAccessPageCard } from "components/access-page/AppAccessPageCard"
import { Form } from "components/views/atoms/forms/Form"
import { FormattedMessage, useIntl } from "react-intl"
import { getErrorMessageFromCode } from "../../utils/CarrotErrors"
import { Box, Link, Stack, useTheme } from "@carrotfertility/carotene-core"
import { UnauthPreferredLocale } from "../views/UnauthPreferredLocale"

const ErrorMessage = styled.p`
  margin: 0;
  text-align: center;
  color: #d26556;
`

const CenteredH1 = styled(H1)`
  text-align: center;
`

const EmailInput = ({ enabled }: { enabled: boolean }): JSX.Element => {
  const {
    register,
    formState: { errors }
  } = useFormContext()
  const { email } = useSignUpFlow()
  const intl = useIntl()
  return (
    <CompleteFormInput
      readOnly={!enabled}
      {...register("email", { required: intl.formatMessage({ defaultMessage: "Email is required" }) })}
      errors={errors}
      showValidation={false}
      defaultValue={email}
      id="email"
      label={intl.formatMessage({ defaultMessage: "Email" })}
      type="email"
      autoFocus
    />
  )
}

function AddEmailToAccountCard(): JSX.Element {
  const { onSubmit, error, loading } = useSignUpFindAccountSuccess()
  const { email } = useSignUpFlow()
  const intl = useIntl()
  const headingCopy = email
    ? intl.formatMessage({ defaultMessage: "Finally, tell us how to reach you" })
    : intl.formatMessage({ defaultMessage: "Tell us how to reach you" })
  const theme = useTheme()

  const getTranslatedErrorMessage = (errorCode) => {
    if (errorCode === "MEMBER_INACTIVE") {
      return intl.formatMessage(getErrorMessageFromCode(errorCode), {
        linkContent: "support@get-carrot.com",
        link: (string) => (
          <Link color="inherit" href="mailto:support@get-carrot.com">
            {string}
          </Link>
        )
      })
    }
    return intl.formatMessage(getErrorMessageFromCode(errorCode))
  }

  return (
    <AppAccessPageCard>
      <Form noValidate onSubmit={onSubmit}>
        <Spacer height={3.5} />
        <FlexContainer justifyContent="center" stack="tiny">
          <CenteredH1>{headingCopy}</CenteredH1>
        </FlexContainer>
        {error && (
          <>
            <Spacer height={0.5} />
            <ErrorMessage>{getTranslatedErrorMessage(error)}</ErrorMessage>
          </>
        )}
        <Spacer height={1.5} />
        <EmailInput enabled />
        <Spacer height={1.5} />
        <Stack spacing={theme.spacing(theme.tokens.spacing.lg)} textAlign={"center"}>
          <ButtonPrimary role="button" onClick={() => !loading && onSubmit()}>
            <FormattedMessage defaultMessage="Continue" />
          </ButtonPrimary>
          <Box display="block" sx={{ alignSelf: "center" }}>
            <UnauthPreferredLocale />
          </Box>
        </Stack>
        <Spacer height={2} />
      </Form>
    </AppAccessPageCard>
  )
}

export default function SignUpFindAccountSuccessPage(): JSX.Element {
  const intl = useIntl()
  return (
    <AppAccessPageLayout title={intl.formatMessage({ defaultMessage: "Tell us how to reach you" })}>
      <AddEmailToAccountCard />
    </AppAccessPageLayout>
  )
}
